import { gql } from '@apollo/client'

export const FEEDBACK_QUERY = gql`
  query feedback($id: ID!) {
    feedback(id: $id) {
      id
      comments
      feedbackTypeId
      feedbackCategory
      feedbackType {
        title
        id
      }
      createdAt
      updatedAt
      resolvementProcessingId
    }
  }
`
